import React from "react";
import "./FormCad.css";
import { Button, Checkbox, Col, Input, Row } from "antd";
import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  FacebookOutlined,
} from "@ant-design/icons";
// import {Link} from "react-router-dom";
import { FiLogIn } from "react-icons/fi";
import { Link } from "react-router-dom";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import * as links from "../../../utils/links";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
const FormCad = (props) => {
  const {
    authTitle,
    authDescription,
    authFields,
    authSubmit,
    authImage,
    onsubmit,
    successMessage,
    errorMessage,
    textImage,
    new_cad,
    forgot_password,
    fieldWidth,
    login
  } = props;
  return (
    <div className="AuthCad_container">
      <Row className="AuthCad_rowContainer">
        <Col xs={24} md={12} lg={12} xl={12} className="AuthCad_colAuthForm">
          <div className="AuthCad_authBlock">
            <div className="AuthCad_authTitle">
              <FiLogIn className="AuthCad_authTitleIcon" />
              <div className="AuthCad_authTitleText">{authTitle}</div>
            </div>
            <div className="AuthCad_authDescription">{authDescription}</div>
            <form className="AuthCad_authForm" onSubmit={onsubmit}>
              {authFields.map((itemField, indexField) => {
                switch (itemField.type) {
                  case "text":
                    return (
                      <div
                        className="AuthCad_itemField"
                        key={indexField}
                        style={{ "--field-width": itemField.width || "100%" }}
                        data-width
                      >
                        <label
                          htmlFor="username"
                          className="AuthCad_itemFieldLabel"
                        >
                          {itemField.label}
                          {itemField.obrigatorio ?
                            <span style={{ color: 'red' }}>*</span>
                            :
                            null
                          }
                        </label>
                        <Input
                          placeholder={itemField.placeholder ?? ""}
                          value={itemField.value}
                          id="username"
                          type="text"
                          name="username"
                          autoComplete="username"
                          onChange={(event) => {
                            if (typeof itemField.setField === "function") {
                              itemField.setField(event.target.value);
                            }
                          }}
                          onKeyPress={(event) => {
                            if (event.key === "Enter") {
                              onsubmit();
                            }
                          }}
                        />
                        {itemField.error && (
                          <div className="AuthCad_itemFieldError">
                            {itemField.error}
                          </div>
                        )}
                      </div>
                    );
                  case "number":
                    return (
                      <div
                        className="AuthCad_itemField"
                        key={indexField}
                        style={{ "--field-width": itemField.width || "100%" }}
                        data-width
                      >
                        <label
                          htmlFor="number"
                          className="AuthCad_itemFieldLabel"
                        >
                          {itemField.label}
                          {itemField.obrigatorio ?
                            <span style={{ color: 'red' }}>*</span>
                            :
                            null
                          }
                        </label>
                        <Input
                          placeholder={itemField.placeholder ?? ""}
                          value={itemField.value}
                          id="number"
                          type="number"
                          name="number"
                          autoComplete="number"
                          onChange={(event) => {
                            if (typeof itemField.setField === "function") {
                              itemField.setField(event.target.value);
                            }
                          }}
                          onKeyPress={(event) => {
                            if (event.key === "Enter") {
                              onsubmit();
                            }
                          }}
                        />
                        {itemField.error && (
                          <div className="AuthCad_itemFieldError">
                            {itemField.error}
                          </div>
                        )}
                      </div>
                    );
                  case "password":
                    return (
                      <div
                        className="AuthCad_itemField"
                        key={indexField}
                        style={{ "--field-width": itemField.width || "100%" }}
                        data-width
                      >
                        <label
                          htmlFor="password"
                          className="AuthCad_itemFieldLabel"
                        >
                          {itemField.label}
                          {itemField.obrigatorio ?
                            <span style={{ color: 'red' }}>*</span>
                            :
                            null
                          }
                        </label>
                        <Input.Password
                          placeholder={itemField.placeholder ?? ""}
                          id="password"
                          value={itemField.value}
                          type="password"
                          name="password"
                          autoComplete="current-password"
                          iconRender={(visible) =>
                            visible ? (
                              <FontAwesomeIcon
                                icon={faEyeSlash}
                              ></FontAwesomeIcon>
                            ) : (
                              <FontAwesomeIcon icon={faEye}></FontAwesomeIcon>
                            )
                          }
                          onChange={(event) => {
                            if (typeof itemField.setField === "function") {
                              itemField.setField(event.target.value);
                            }
                          }}
                          onKeyPress={(event) => {
                            if (event.key === "Enter") {
                              onsubmit();
                            }
                          }}
                        />
                        {itemField.error && (
                          <div className="AuthCad_itemFieldError">
                            {itemField.error}
                          </div>
                        )}
                      </div>
                    );
                  default:
                    return null;
                }
              })}
            </form>
            <Button
              className="AuthCad_authSubmit"
              onClick={() => {
                if (typeof onsubmit === "function") {
                  onsubmit();
                }
              }}
            >
              {authSubmit}
            </Button>
            {forgot_password ?
              <div style={{ textAlign: 'center', marginTop: 20 }}>
                <a href={links.FORGOTPASSWORD}>Esqueceu a Senha? Clique aqui</a>
              </div>
              :
              null
            }
            {new_cad ?
              <div style={{ textAlign: 'center', marginTop: 10 }}>
                <a href={links.SIGNIN}>Ja possui cadastro? Faça Login</a>
              </div>
              :
              null
            }
            {login ?
              <div style={{ textAlign: 'center', marginTop: 20 }}>
                <a href={links.SIGNIN}>Possui Usuário e Senha? Fazer Login</a>
              </div>
              :
              null
            }

            {successMessage && (
              <div className="AuthCad_successMessage">{successMessage}</div>
            )}
            {errorMessage && (
              <div className="AuthCad_errorMessage">
                <div dangerouslySetInnerHTML={{ __html: errorMessage }}></div>
              </div>
            )}
          </div>
        </Col>
        {
          <Col xs={24} md={12} lg={12} xl={12} className="AuthCad_colAuthImage">
            {authImage && (
              <img className="AuthCad_authImage" src={authImage} alt="auth" />
            )}
            {/* {
                        textImage && (
                            <p className="LogoTextImage CenteredText">
                                {textImage}
                            </p>
                        )
                    } */}
            {textImage && (
              <div className="LogoTextImage CenteredText">
                {textImage}
                <div className="MediaIcons">
                  <a
                    href="https://w.app/ikpaysistema"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faFacebook} className="SocialIcon" />
                  </a>
                  <a
                    href="https://w.app/ikpaysistema"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faInstagram}
                      className="SocialIcon InstagramIcon"
                    />
                  </a>
                  <a
                    href="https://w.app/ikpaysistema"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faWhatsapp}
                      className="SocialIcon WhatsIcon"
                    />
                  </a>
                </div>
              </div>
            )}
          </Col>
        }
      </Row>
    </div>
  );
};

export default FormCad;
